// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedMint } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Mint';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useExecutedMints2Step = (): TemplateHistory<ExecutedMint> =>
  useTemplateHistory(ExecutedMint);
